import { field, readContract, writeContractAndWait } from "../viem";
import MafiaSafehouseAbi from "../../abis/MafiaSafehouse.json";
import config from "../../config/config";

const address = config.safehouseAddress;
const abi = MafiaSafehouseAbi;

const toUnixSeconds = (value: unknown) => {
  const seconds = Number(value);
  return Number.isFinite(seconds) && seconds > 0 ? Math.floor(seconds) : 0;
};

export interface SafehouseUserInfo {
  safeUntil: number;
  duration: number;
  nextSafehouseTime: number;
}

export const getSafehouseUserInfo = async (
  userAddress: string,
  signMsg: string,
  signature: string
): Promise<SafehouseUserInfo> => {
  const info = await readContract({
    address,
    abi,
    functionName: "getUserInfo",
    args: [userAddress, JSON.stringify(signMsg), signature],
  });

  return {
    safeUntil: toUnixSeconds(field(info, "safeUntil", 0)),
    duration: toUnixSeconds(field(info, "duration", 1)),
    nextSafehouseTime: toUnixSeconds(field(info, "nextSafehouseTime", 2)),
  };
};

export const enterSafehouse = async (account: string, hours: number) => {
  const tx = await writeContractAndWait({
    address,
    abi,
    functionName: "enterSafehouse",
    args: [hours],
    account,
  });
  return tx.transactionHash;
};

export const exitSafehouse = async (account: string) => {
  const tx = await writeContractAndWait({
    address,
    abi,
    functionName: "exitSafehouse",
    args: [],
    account,
  });
  return tx.transactionHash;
};
